/** Tile centers in the left expression. Shared by renderer and geometry checks. */
export const expressionSymbolSlots = { plus: { x: 370, width: 36 }, constant: { x: 429, width: 65 } };
export function leftTileLayout(xCount: number, unitCount: number) {
  return {
    unknowns: Array.from({ length: xCount }, (_, i) => ({ x: 253 + i % 3 * 54, y: 204 + Math.floor(i / 3) * 80, width: 46, height: 68 })),
    units: Array.from({ length: unitCount }, (_, i) => ({ x: 426 + i % 4 * 34, y: 183 + Math.floor(i / 4) * 34, width: 28, height: 28 })),
  };
}
